import { useContext } from "react";
import { AppContext } from "../App";
import { FiZap, FiGlobe, FiLayers } from "react-icons/fi";

export default function WellnessPreventive() {
  const appContext = useContext(AppContext);

  const services = [
    {
      icon: <FiZap />,
      title: "Corporate Wellness Programs",
      desc: "Packaged corporate physical group screening protocols and health interventions delivered on-site at premises or inside our medical center network."
    },
    {
      icon: <FiGlobe />,
      title: "Travel Medicine & International Health Certificates",
      desc: "Pre-travel health consults, essential vaccine provisions (including Yellow Fever with official card generation), and post-travel tropical pathogen screenings."
    },
    {
      icon: <FiLayers />,
      title: "Health Education Promotion Center",
      desc: "Structured clinical education structures running group wellness modules, systematic community outreach protocols, and continuous digital health campaigns."
    }
  ];

  return (
    <div className="pillar-container">
      <div className="pillar-header">
        <span className="pillar-tag">Pillar VI</span>
        <h2 className="pillar-title">Wellness & Preventive Care</h2>
        <p className="pillar-subtitle">Proactive lifestyle monitoring programs engineered to intercept downstream clinical pathologies.</p>
      </div>

      <div className="pillar-grid">
        {services.map((item, idx) => (
          <div 
            key={idx} 
            className="pillar-card"
            onClick={() => appContext?.navTo?.({ item: "services", extra: "wellness-details" })}
          >
            <div className="pillar-icon">{item.icon}</div>
            <h3 className="pillar-card-title">{item.title}</h3>
            <p className="pillar-card-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}